module.exports = __webpack_public_path__ + "img/fig21.ec111928.jpg";